import { Link } from "react-router-dom";
import { ArrowRight, CupSoda } from "lucide-react";
import CupImage from "@/components/merch/CupImage";
import {
    CUP_BASE_KES,
    CUSTOM_NAME_KES,
    PACK_SIZE,
    STICKER_KES,
} from "@/data/merchCups";

export default function MerchSection() {
    return (
        <section
            id="merch"
            data-testid="home-merch-section"
            className="py-16 sm:py-24 bg-zinc-950 text-white"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
                <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
                    <div>
                        <p className="text-sm font-medium text-[#E54D2E] uppercase tracking-wider mb-3">
                            Merch
                        </p>
                        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-black tracking-tight leading-[1.05]">
                            Branded party cups
                        </h2>
                        <p className="mt-4 text-white/70 text-lg max-w-md leading-relaxed">
                            Six colours, packs of {PACK_SIZE}. KES {CUP_BASE_KES}{" "}
                            plain · +KES {STICKER_KES} team sticker · +KES{" "}
                            {CUSTOM_NAME_KES} custom name. Pay with M-Pesa.
                        </p>
                        <Link
                            to="/merch/cups"
                            data-testid="merch-cta"
                            className="inline-flex items-center gap-2 mt-8 h-12 px-6 rounded-full bg-[#E54D2E] text-white font-medium hover:bg-white hover:text-zinc-950 transition-colors"
                        >
                            <CupSoda className="h-4 w-4" />
                            Shop cups
                            <ArrowRight className="h-4 w-4" />
                        </Link>
                    </div>
                    <div className="grid grid-cols-3 gap-3 sm:gap-4">
                        {["red", "green", "blue", "mustard", "yellow", "black"].map(
                            (id) => (
                                <CupImage
                                    key={id}
                                    colorId={id}
                                    className="aspect-[3/4] w-full rounded-xl ring-1 ring-white/10"
                                />
                            )
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
